"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPotencyValueFromMetaData = exports.getValueFromMetaData = exports.convertStrMetaDataToNumber = exports.isNullOrUndefined = void 0;
const products_1 = require("@getgreenline/products");
const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
};
exports.isNullOrUndefined = isNullOrUndefined;
const convertStrMetaDataToNumber = ({ metaData, key, }) => {
    return (0, exports.isNullOrUndefined)(metaData[key]) ? null : Number(metaData[key]);
};
exports.convertStrMetaDataToNumber = convertStrMetaDataToNumber;
const getValueFromMetaData = (metaData, rangeKey, key) => {
    return metaData[products_1.MetaDataModels.MetaDataReservedKeys.SHOW_MAX_MIN] === 'true'
        ? (0, exports.convertStrMetaDataToNumber)({
            key: rangeKey,
            metaData,
        })
        : (0, exports.convertStrMetaDataToNumber)({
            key,
            metaData,
        });
};
exports.getValueFromMetaData = getValueFromMetaData;
const getPotencyValueFromMetaData = (metaData, rangeLimit, potencyKey, potencyFilterOptions) => {
    const rangeKey = rangeLimit === 'max'
        ? potencyFilterOptions.getMaxValueKey(potencyKey)
        : potencyFilterOptions.getMinValueKey(potencyKey);
    return (0, exports.getValueFromMetaData)(metaData, rangeKey, potencyFilterOptions.getSingleValueKey(potencyKey));
};
exports.getPotencyValueFromMetaData = getPotencyValueFromMetaData;
//# sourceMappingURL=metaDataHelpers.js.map